const dashboard = {
  CreateNewJob: 'Create New Job',
  JobListings: {
    Title: 'Job Listings',
    Filter: {
      Status: 'Status',
      JobType: 'Type',
    },
    Sort: {
      Priority: 'Priority first',
    },
  },
};

export default dashboard;
